<template>
  <v-container
    class="files-view-container"
    fluid
  >
    <h1>Files</h1>
    <files-table
      :files="files"
      :loading="loading"
      @refreshFileTable="refreshFiles"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import FilesTable from '@/components/financialProducts/FilesTable';

export default {
  name: 'Files',
  components: {
    'files-table': FilesTable,
  },
  computed: {
    ...mapState({
      loading: state => state.filesStore.loading,
      files: state => state.filesStore.files,
    }),
  },
  mounted() {
    this.refreshFiles();
  },
  methods: {
    ...mapActions(['getFiles']),
    async refreshFiles(category = 'agb') {
      this.getFiles(toQueryString({ category }));
    },
  },
};
</script>


<style lang="scss" scoped>
.files-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/financialProducts/Files.vue